import { render } from "./AddUserToModuleParticipants.vue?vue&type=template&id=bf483a7c&scoped=true&ts=true"
import script from "./AddUserToModuleParticipants.vue?vue&type=script&lang=ts"
export * from "./AddUserToModuleParticipants.vue?vue&type=script&lang=ts"

import "./AddUserToModuleParticipants.vue?vue&type=style&index=0&id=bf483a7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf483a7c"]])

export default __exports__